// Static data for the Hero component

export const HERO_SLIDES = [
  {
    id: 'da-nang-pagoda',
    image: 'https://images.unsplash.com/photo-1545569341-9eb8b30979d9?q=80&w=1920&auto=format&fit=crop',
    caption: 'Pagoda in Da Nang, Vietnam',
  },
];

export const HERO_CONTENT = {
  eyebrow: 'Vietnam Destination Management Company',
  heading: 'Vietnam, Composed With Precision.',
  subheading:
    'Seamless journeys, exceptional experiences.',
  ctaPrimary: { label: 'Become a Partner', path: '/partner-with-us' },
  ctaSecondary: { label: 'Explore as Customer', path: '/destinations' },
};
